import { appUrls } from "../../utils/urls/appUrls";

// import TransactionHistory from '../../app/pages/CertificateManagement/TransactionHistory'
import { HomePage } from "../../app/pages";

export const guestRoutes = [
  {
    url: appUrls.home_page,
    component: <HomePage />,
    routeType: "private",
  },
];
